import React from 'react';
import Categories from './Categories';
import VisitLabels from './VisitLabels';

function LabelsAndCategories() {
	return (
		<div>
			<VisitLabels />
			<Categories />
		</div>
	);
}

export default LabelsAndCategories;
